import PropTypes from 'prop-types'
import { Typography, Stack, styled, alpha } from '@mui/material'
import Logo from '../../components/logo'
import { StyledRoot, StyledSectionBg, StyledContent } from './styles'
import { bgGradient } from '../../utils/cssStyles'

LoginLayout.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    illustration: PropTypes.string,
};

export default function LoginLayout({ children, illustration, title }) {

    const StyledSection = styled('div')(({ theme }) => ({
        display: 'none',
        position: 'relative',
        [theme.breakpoints.up('md')]: {
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            ...bgGradient({
                color: alpha(theme.palette.background.default, theme.palette.mode === 'light' ? 0.3 : 0.75),
                imgUrl: '/assets/illustrations/login-back.jpg',
            }),
        },
    }))

    return (
        <StyledRoot>
            <Logo
                sx={{
                    zIndex: 9,
                    position: 'absolute',
                    mt: { xs: 1.5, md: 5 },
                    ml: { xs: 2, md: 5 },
                }}
            />
            <StyledSection>
                <Typography variant="h3" sx={{ mb: 2, maxWidth: 480, textAlign: 'center' }}>
                    Sistema Punto de Venta
                </Typography>
                <Typography variant="h1" sx={{ mb: 10, maxWidth: 480, textAlign: 'center' }}>
                    INGENIA REST
                </Typography>
                <StyledSectionBg />
            </StyledSection>
            <StyledContent>
                <Stack sx={{ width: 1 }}> {children} </Stack>
            </StyledContent>
        </StyledRoot>
    )
}
